import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import Button from "components/Button";
import Image from "components/Image";
import { useOnClickOutside } from "hooks";
import { SET_FREEZE } from "store/actionTypes";
import generateSrcSet, { commonSourceSets } from "style/generateSrcSet";

import {
    ButtonContainer,
    ImageContainer,
    StyledLightBox,
} from "./LightBox.styled";
import { LightBoxProps } from "./LightBoxProps";

const LightBox = ({
    alt,
    identifier,
    imgUrl,
    uploadedHeight,
    uploadedWidth,
    l18n,
    setImgUrl,
}: LightBoxProps) => {
    const dispatch = useDispatch();
    const dialogRef = useRef<HTMLDialogElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const imageSrcSet = imgUrl
        ? generateSrcSet({
              image: imgUrl,
              content: commonSourceSets.large,
              maxWidth: uploadedWidth,
              maxHeight: uploadedHeight,
              format: "jpg",
          })
        : undefined;

    const hideLightBox = () => {
        setImgUrl(undefined);
        dialogRef?.current?.close();
        dispatch({ type: SET_FREEZE, payload: false });
    };

    if (imgUrl) {
        dialogRef?.current?.showModal();
        dispatch({ type: SET_FREEZE, payload: true });
    }

    useOnClickOutside(contentRef, hideLightBox);

    return (
        <StyledLightBox
            ref={dialogRef}
            id={`lightbox-modal-${identifier}`}
            aria-modal="true"
        >
            <div ref={contentRef}>
                <ButtonContainer>
                    <Button iconOnly icon="close28" onClick={hideLightBox}>
                        {l18n?.closeLabel ?? "Close"}
                    </Button>
                </ButtonContainer>
                <ImageContainer>
                    <Image
                        identifier={`lightbox-image-${identifier}`}
                        alt={alt}
                        srcSet={imageSrcSet}
                        lightbox={false}
                        url={imgUrl}
                        lazyload={false}
                    />
                </ImageContainer>
            </div>
        </StyledLightBox>
    );
};

export default LightBox;
